import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect',
  templateUrl: './app-redirect.component.html',
  styleUrls: ['./app-redirect.component.css']
})
export class AppRedirectComponent implements OnInit {

    ngOnInit(): void {
        console.log('Redirecting to external portal...');
    }
    
    redirectToPortal(): void {
        window.location.href = environment.AM_PORTAL_URL;
    }
}
